"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertUnit = exports.isUnit = exports.CeriseUnit = exports.Unit = void 0;
var Unit;
(function (Unit) {
    Unit["BIN"] = "BIN";
    Unit["CAM"] = "CAM";
    Unit["CBG"] = "CBG";
    Unit["CEBR"] = "CEBR";
    Unit["CEDE"] = "CEDE";
    Unit["CEES"] = "CEES";
    Unit["CEIT"] = "CEIT";
    Unit["CEUK"] = "CEUK";
    Unit["CLE"] = "CLE";
    Unit["CTM"] = "CTM";
    Unit["FATV"] = "FATV";
    Unit["FRGTS"] = "FRGTS";
    Unit["FROMM"] = "FROMM";
    Unit["GALA"] = "GALA";
    Unit["GEO"] = "GEO";
    Unit["HCO"] = "HCO";
    Unit["IDE"] = "IDE";
    Unit["MLK"] = "MLK";
    Unit["NEON"] = "NEON";
    Unit["NGE"] = "NGE";
    Unit["PECO"] = "PECO";
    Unit["PFEM"] = "PFEM";
    Unit["PMO"] = "PMO";
    Unit["PTVS"] = "PTVS";
    Unit["MAD"] = "MAD";
    Unit["SHG"] = "SHG";
    Unit["TGL"] = "TGL";
    Unit["TLZ"] = "TLZ";
    Unit["TRV"] = "TRV";
    Unit["TVS"] = "TVS";
    Unit["VOICI"] = "VOICI";
    Unit["HBZ"] = "HBZ";
    Unit["TESTUNIT"] = "TEST-UNIT";
})(Unit = exports.Unit || (exports.Unit = {}));
var CeriseUnit;
(function (CeriseUnit) {
    CeriseUnit["CEBR"] = "CEBR";
    CeriseUnit["CEDE"] = "CEDE";
    CeriseUnit["CEES"] = "CEES";
    CeriseUnit["CEIT"] = "CEIT";
    CeriseUnit["CEUK"] = "CEUK";
    CeriseUnit["FRGTS"] = "FRGTS";
    CeriseUnit["FROMM"] = "FROMM";
})(CeriseUnit = exports.CeriseUnit || (exports.CeriseUnit = {}));
function isUnit(maybeUnit) {
    return Object.entries(Unit).some(([, unit]) => unit === maybeUnit);
}
exports.isUnit = isUnit;
function assertUnit(maybeUnit) {
    if (!isUnit(maybeUnit)) {
        throw new Error(`The unit "${maybeUnit}" does not exist.`);
    }
    return maybeUnit;
}
exports.assertUnit = assertUnit;
//# sourceMappingURL=unit.js.map